/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PatientPatientNotifyType,
  PatientPatientNotifyTypeFromJSON,
  PatientPatientNotifyTypeFromJSONTyped,
  PatientPatientNotifyTypeToJSON,
} from "./";

export const GetPatientNotifyTypesResponseTypename = "GetPatientNotifyTypesResponse" as const;

/**
 *
 * @export
 * @interface GetPatientNotifyTypesResponse
 */
export interface GetPatientNotifyTypesResponse {
  /**
   *
   * @type {number}
   * @memberof GetPatientNotifyTypesResponse
   */
  count?: number;
  /**
   *
   * @type {Array<PatientPatientNotifyType>}
   * @memberof GetPatientNotifyTypesResponse
   */
  patientNotifyTypes?: Array<PatientPatientNotifyType>;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetPatientNotifyTypesResponse
   */
  readonly __typename?: string;
}

export function GetPatientNotifyTypesResponseFromJSON(json: any): GetPatientNotifyTypesResponse {
  return GetPatientNotifyTypesResponseFromJSONTyped(json, false);
}

export function GetPatientNotifyTypesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPatientNotifyTypesResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetPatientNotifyTypesResponseTypename,

    count: !exists(json, "count") ? undefined : json["count"],
    patientNotifyTypes: !exists(json, "patient_notify_types")
      ? undefined
      : (json["patient_notify_types"] as Array<any>).map(PatientPatientNotifyTypeFromJSON),
  };
}

export function GetPatientNotifyTypesResponseToJSON(object?: GetPatientNotifyTypesResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    count: value.count,
    patient_notify_types:
      value.patientNotifyTypes === undefined
        ? undefined
        : (value.patientNotifyTypes as Array<any>).map(PatientPatientNotifyTypeToJSON),
  };
}
